import React, { useState, useEffect } from "react";
import clsx from "clsx";
import {
  Grid,
  makeStyles,
  Typography,
  TextField,
  Button,
} from "@material-ui/core";
import ReactExport from "react-export-excel";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputMask from "react-input-mask";
import SearchIcon from "@material-ui/icons/Search";
import { green } from "@material-ui/core/colors";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { connect } from "react-redux";

import { SiteService } from "../../../../../services/site.service";
import AccesoryByBarCode from "../../../modals/AccesoryByBarCode";
import { AuthService } from "../../../../../services/auth.service";
import { ProductService } from "../../../../../services/product.service";
import styles from "../../../../../styles/global-styles";
import { actions } from "../../../../../redux/actions/alert";
import BrandSelect from "../../../../shared/selects/BrandSelect";
import ModelSelect from "../../../../shared/selects/ModelSelect";
import SubcategorySelect from "../../../../shared/selects/SubcategorySelect";
import { getAccesoriesByFilters } from "../../utils.inventory";
import { Link } from "react-router-dom";
import { AccesoryService } from "../../../../../services/accesory.service";
import BackDrop from "../../../../shared/backdrop/Backdrop";

const useStyles = makeStyles((theme) => ({
  title: styles.title,
  rightButton: styles.buttonRightHeader,
  header: styles.header,
  wrapper: {
    margin: theme.spacing(2),
    display: "inline",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    marginRight: 50,
    color: "#ffffff",
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  divFilters: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
}));

const AccesoryHeaderBySite = ({
  addAlert,
  detailAlert,
  storeInventory,
  accesoriesFound,
}) => {
  const classes = useStyles();

  //excel variables
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  const [barCode, setBarCode] = useState("");
  const [availablesInSiteExcel, setAvailablesInSiteExcel] = useState([]);
  const [siteName, setSiteName] = useState({});
  const [accesoryByBarCode, setAccesoryByBarCode] = useState({});

  // new states
  const [queryParams, setqueryParams] = useState({});
  const [productsAvailable, setProductsAvailable] = useState(null);

  useEffect(() => {
    if (!storeInventory) {
      (async () => {
        try {
          /** Recover site name */
          const { siteId } = AuthService.currentUserValue;
          const response = await SiteService.getSiteById(siteId);
          setSiteName(response.data[0]?.name || "");

          /** Service for build excel for imports */
          const {
            data: { accesoryArray, count },
          } = await ProductService.getProductAccesoriesWithAvailability({
            siteId,
            inDistribution: 0,
          });
          console.log("totalArrayWithAvailability", accesoryArray);
          console.log("totalArrayWithAvailability counter", count);
          setAvailablesInSiteExcel(accesoryArray);

          // const fakeData = [
          //   {
          //     "accesory.barCode": "7000000000000",
          //     "accesory.brand": "APPLE",
          //     "accesory.color": "N/A",
          //     "accesory.cost": 100,
          //     "accesory.createdAt": "2021-04-28 14:22:19",
          //     "accesory.discount": 0,
          //     "accesory.id": 37,
          //     "accesory.inDistribution": 0,
          //     "accesory.model": "IPH ORIG 5W",
          //     "accesory.price": 150,
          //     "accesory.provider.alias": "BODMX",
          //     "accesory.provider.id": 2,
          //     "accesory.provider.name": "BODEGA MX",
          //     "accesory.provider.timeGuarantee": 0,
          //     "accesory.providerId": 2,
          //     "accesory.site.id": 3,
          //     "accesory.site.name": "PINAL 1",
          //     "accesory.siteId": 3,
          //     "accesory.subcategoryTypeId": 5,
          //     "accesory.subcategory_type.id": 5,
          //     "accesory.subcategory_type.name": "Cargadores",
          //     "accesory.updatedAt": "2021-07-13 15:28:18",
          //     accesoryId: 37,
          //     balanceTransferId: null,
          //     cashCardId: null,
          //     chipId: null,
          //     createdAt: "2021-04-28 14:22:20",
          //     factureCreated: null,
          //     id: "f377e75a-17cf-46cf-a47a-1f9aa6ae071d",
          //     movileId: null,
          //     phonePlanId: null,
          //     productSold: null,
          //     productTypeId: 2,
          //   },
          // ];
          // setTimeout(() => setAvailablesInSiteExcel(fakeData), 3000);

          return () => {
            setAvailablesInSiteExcel([]);
          };
        } catch (error) {
          console.log(error);
          addAlert({ showAlert: true });
          detailAlert({
            severity: "error",
            message: error.msgs || "Error al generar archivo excel",
          });
        }
      })();
    }
  }, []);

  const buttonClassname = clsx({
    [classes.buttonSuccess]: availablesInSiteExcel.length > 0,
  });

  const searchAccesoryByBarCode = async () => {
    try {
      const { siteId } = AuthService.currentUserValue;
      const queryParams = {
        barCode,
        siteId: storeInventory ? null : siteId,
        inDistribution: 0,
        productSold: 0,
      };
      const { data } = await ProductService.getProductByAccesoriesWithParams(
        queryParams
      );
      console.log("accesory detail", data);
      if (data.length > 0)
        setAccesoryByBarCode({
          accesory: data[0].accesory,
          totalAccesories: data.length,
        });
      else {
        throw queryParams;
      }
    } catch (error) {
      console.log("error", error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message: `No se encontró accesorio asociado al código de barras ${
          error?.barCode || ""
        }`,
        time: 3000,
      });
    }
  };

  const handleCloseModal = () => setAccesoryByBarCode({});

  const handleQuerySelected = (key, value) => {
    if (key === "brand" && queryParams.model) {
      setqueryParams({
        ...queryParams,
        model: "",
        [key]: value === "none" ? "" : value,
      });
    } else
      setqueryParams({ ...queryParams, [key]: value === "none" ? "" : value });
  };

  const searchProductByFilters = async () => {
    setProductsAvailable(false);
    const { siteId } = AuthService.currentUserValue;
    try {
      const body = {
        ...queryParams,
        // siteId: storeInventory ? null : siteId,
        inDistribution: 0,
        page: 0,
        limit: 10,
      };
      console.log("queryParams", body);
      const {
        data: { accesories, count },
      } = await AccesoryService.getAccesoriesBySitesAndStoreParamsPaginated(
        body
      );
      console.log("accesories WITH queryParams", accesories);
      console.log("accesories length ", count);

      if (accesories.length) {
        accesoriesFound({
          accesories,
          count,
          queryParams,
        });
      } else {
        const error = {
          notFoundMsg:
            "No se encontraron accesorios con los filtros seleccionados",
        };
        throw error;
      }
      setProductsAvailable(true);
    } catch (error) {
      console.log("error searchProductByFilters", error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: error.notFoundMsg ? "warning" : "error",
        message: error.notFoundMsg
          ? error.notFoundMsg
          : error.msgs || "Error al procesar tu solicitud",
      });
      setProductsAvailable(true);
    }
  };

  return (
    <>
      {/* Modal for accesory found by bar code */}
      {accesoryByBarCode.accesory &&
        Object.values(accesoryByBarCode.accesory).length > 0 && (
          <AccesoryByBarCode
            open={Object.values(accesoryByBarCode).length > 0}
            onClose={handleCloseModal}
            detailProduct={accesoryByBarCode.accesory}
            totalAccesories={accesoryByBarCode.totalAccesories}
            searchBySite={!storeInventory}
          />
        )}

      <Typography
        style={{
          marginRight: 30,
          display: storeInventory ? "block" : "inline",
        }}
        className={classes.title}
      >
        Inventario accesorios
      </Typography>
      {!storeInventory ? (
        <ExcelFile
          element={
            <div className={classes.wrapper}>
              <Button
                className={buttonClassname}
                disabled={!availablesInSiteExcel.length}
              >
                Exportar a excel
              </Button>
              {availablesInSiteExcel.length === 0 && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
          }
          filename={`Sucursal ${siteName}`}
        >
          <ExcelSheet
            data={availablesInSiteExcel}
            name={`Sucursal ${siteName}`}
          >
            <ExcelColumn label="Marca" value={(col) => col["brand"]} />
            <ExcelColumn label="Modelo" value={(col) => col["model"]} />
            <ExcelColumn
              label="Subcategoría"
              value={(col) => col["subcategoryName"]}
            />
            <ExcelColumn
              label="Código de barras"
              value={(col) => col["barCode"]}
            />
            <ExcelColumn label="Precio" value={(col) => col["price"]} />
            <ExcelColumn label="Descuento" value={(col) => col["discount"]} />
            <ExcelColumn
              label="Disponibilidad"
              value={(col) => col["totalProducts"] || 0}
            />
          </ExcelSheet>
        </ExcelFile>
      ) : (
        <div className={classes.divFilters}>
          <Grid item>
            <BrandSelect
              brand={handleQuerySelected}
              isMovile={false}
              brandSelect={queryParams.brand}
            />
          </Grid>
          {queryParams.brand && (
            <Grid item>
              <ModelSelect
                brand={queryParams.brand}
                model={handleQuerySelected}
                isMovile={false}
                modelOption={queryParams.model}
              />
            </Grid>
          )}
          <Grid item>
            <SubcategorySelect
              formOption={false}
              subcategory={handleQuerySelected}
              option={queryParams.subcategoryTypeId}
            />
          </Grid>

          <Grid item>
            <Button
              disabled={!Object.keys(queryParams).length}
              style={{ marginTop: 20 }}
              className={classes.rightButton}
              variant="contained"
              onClick={searchProductByFilters}
              color="primary"
              endIcon={<SearchIcon color="secondary" />}
            >
              Filtrar
            </Button>
          </Grid>
        </div>
      )}

      <Grid
        style={{ marginTop: 15 }}
        container
        direction="row"
        justify="flex-start"
        spacing={4}
        alignItems="center"
      >
        <Grid item>
          <Typography className={classes.header}>
            Filtrar por código de barras
          </Typography>
        </Grid>
        <Grid item>
          <InputMask
            mask="99999999999999999999"
            maskChar=""
            value={barCode || ""}
            onChange={(e) => setBarCode(e.target.value)}
          >
            {() => (
              <TextField
                name="barCode"
                placeholder="Código de barras"
                variant="outlined"
              />
            )}
          </InputMask>
        </Grid>
        <Grid item>
          <Button
            className={classes.rightButton}
            disabled={barCode.length === 0}
            variant="contained"
            onClick={searchAccesoryByBarCode}
            color="primary"
            endIcon={<SearchIcon color="secondary"></SearchIcon>}
          >
            Buscar
          </Button>
        </Grid>
      </Grid>
      {storeInventory && (
        <Link
          to={{ pathname: `../inventario/captura`, state: { tabOption: 2 } }}
          className={classes.link}
        >
          <Button
            style={{ marginTop: 13 }}
            className={classes.rightButton}
            variant="contained"
            color="primary"
            endIcon={<AddCircleIcon color="secondary"></AddCircleIcon>}
          >
            Agregar inventario
          </Button>
        </Link>
      )}

      {productsAvailable === false && (
        <BackDrop
          style={{
            zIndex: 1,
            color: "#1C2668",
          }}
          isOpen={!productsAvailable}
        />
      )}
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(AccesoryHeaderBySite);
